import moment from 'moment';

const TrafficConfigListColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    width: 80
  },
  {
    title: 'Config Name',
    dataIndex: 'configName',
    slot: 'configName',
    width: 180
  },
  {
    title: 'Domain',
    dataIndex: 'domain',
    slot: 'domain',
    width: 250
  },
  {
    title: 'Traffic Status',
    dataIndex: 'status',
    slot: 'status',
    width: 150,
    sorter: (a, b) => (a.status || '').localeCompare(b.status || '')
  },
  {
    title: 'Last Activated At',
    dataIndex: 'lastActivatedAt',
    slot: 'lastActivatedAt',
    width: 150,
    sorter: (a, b) => moment(a.lastActivatedAt).diff(moment(b.lastActivatedAt)),
  },
  {
    title: 'Last Activated By',
    dataIndex: 'lastActivatedBy',
    slot: 'lastActivatedBy',
    width: 200
  },
  {
    title: 'Auto Failover',
    dataIndex: 'autoFailover',
    slot: 'autoFailover',
    width: 280
  },
  {
    title: '',
    dataIndex: '',
    width: 50,
    slot: 'operation'
  }
];

export { TrafficConfigListColumn };
